import * as React from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {accessGroupMemberColumns} from "utils/DataBase";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TablePagination from "@mui/material/TablePagination";
import {useEffect, useState} from "react";
import {useTheme} from "@emotion/react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";
import {deletePermissionMember, getGroupPermissionMember, postNewPermissionMember} from 'api/Api';
import Alert, {useAlert} from "components/snacks/Alert";
import CircularProgress from "@mui/material/CircularProgress";

function TablePaginationActions(props) {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    useEffect(() => {
        const selector = document.querySelector('#memberPagination p');
        if (selector) {
            selector.classList.add('yekan-font');
            selector.innerHTML = 'ردیف در هر صفحه';
        }
    }, []);

    return (
        <Box sx={{flexShrink: 0, ml: 2.5}}>
            <IconButton
                sx={{mr: 2.5}}
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>

            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft/>
                ) : (
                    <KeyboardArrowRight/>
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight/>
                ) : (
                    <KeyboardArrowLeft/>
                )}
            </IconButton>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

const AccessGroupMember = ({group_id, group_name, closeModal}) => {
    const [len, setLen] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [members, setMembers] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [acceptDelete, setAcceptDelete] = useState(0);

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getMembers = () => {
        setLoading(true);
        getGroupPermissionMember(group_id, (isOk, data) => {
            if (isOk) {
                setMembers(data.members);
                setLen(data.members.length);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
            setLoading(false);
        })
    }

    const addMember = (e) => {
        e.preventDefault();
        if (!phoneNumber) {
            return alertStore.AddAlert({
                key: '400',
                message: "لطفا شماره تلفن یا ایمیل را وارد کنید",
                severity: 'error',
                auto_hide: true
            });
        }
        setLoading(true);
        const formData = new FormData();
        formData.append('group_id', group_id);
        formData.append('user_mobile', phoneNumber);
        postNewPermissionMember(formData, (isOk, data) => {
            if (!isOk) {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'error',
                    auto_hide: true
                });
                setLoading(false);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'success',
                    auto_hide: true
                });
            }
            getMembers();
            setPhoneNumber('');
        })
    }

    const handleDelete = (row) => {
        setLoading(true);
        deletePermissionMember(row.id, (isOk, data) => {
            if (!isOk) {
                alertStore.AddAlert({
                    key: '400',
                    message: 'خطای سرور ...',
                    severity: 'error',
                    auto_hide: true
                });
                setLoading(false);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'success',
                    auto_hide: true
                });
            }
            getMembers();
            setAcceptDelete(0);
        })
    }

    useEffect(() => {
        getMembers()
    }, []);

    useEffect(() => {
        const selector = document.querySelector('#memberPagination p');
        if (selector) {
            selector.classList.add('yekan-font');
            selector.innerHTML = 'ردیف در هر صفحه';
        }
    }, [members, loading]);

    return (
        <>
            <div className="modal fade show d-block" id="submitModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5"
                                id="exampleModalLabel">
                                <span>اعضای گروه دسترسی </span>
                                <span>"{group_name}"</span>
                            </h1>
                            <button type="button" className="btn-close"
                                    onClick={closeModal}></button>
                        </div>
                        {loading ? <>
                            <div className="modal-body">
                                <div
                                    className={"d-flex justify-content-center align-items-center"}>
                                    <Box sx={{display: 'flex', marginLeft: '15px'}}>
                                        <CircularProgress/>
                                    </Box>
                                </div>
                            </div>
                        </> : <>
                            <form className="d-flex justify-content-around align-items-end px-4 pt-4" method={'post'}
                                  onSubmit={addMember}>
                                <div className={'w-50'}>
                                    <label htmlFor="add_member_phone">افزودن عضو</label>
                                    <input
                                        type="text"
                                        id={"add_member_phone"}
                                        className={"form-control"}
                                        placeholder={"شماره همراه یا ایمیل"}
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                    />
                                </div>
                                <button type="submit" className={"btn btn-success ms-5"}>افزودن</button>
                            </form>
                            <hr/>
                            {members.length ? <>
                                <TableContainer className="d-none d-md-block">
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead sx={{BackgroundColor: '#eaeaea'}}>
                                            <TableRow>
                                                {accessGroupMemberColumns?.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={{
                                                            minWidth: column.minWidth,
                                                            fontFamily: 'yekan',
                                                            fontSize: '1em',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {members &&
                                                members
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    ?.map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={index}
                                                                style={{
                                                                    backgroundColor:
                                                                        index % 2 === 0 ? '#f3f3f3' : ''
                                                                }}
                                                            >
                                                                {accessGroupMemberColumns?.map((column) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            key={column.id}
                                                                            align={column.align}
                                                                            sx={{
                                                                                fontFamily: 'yekan !important'
                                                                            }}
                                                                        >
                                                                            {column.id === 'id' && (
                                                                                <span>{index + 1}</span>
                                                                            )}
                                                                            {column.id === 'user_full_name' && (
                                                                                <span>{value ? value : '-'}</span>
                                                                            )}
                                                                            {column.id === "action" && (
                                                                                <>
                                                                                    {acceptDelete === row.id ? <>
                                                                                        <button
                                                                                            onClick={() => setAcceptDelete(0)}
                                                                                            className={'btn btn-sm btn-warning'}>
                                                                                            انصراف
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={() => handleDelete(row)}
                                                                                            className={"btn btn-sm btn-danger ms-1"}>
                                                                                            حذف کن
                                                                                        </button>
                                                                                    </> : <button
                                                                                        onClick={() => setAcceptDelete(row.id)}
                                                                                        className={"btn btn-sm btn-danger ms-1"}>
                                                                                        حذف
                                                                                    </button>}
                                                                                </>
                                                                            )}
                                                                            {column.id !== 'id' &&
                                                                                column.id !== 'action' &&
                                                                                column.id !== 'user_full_name' && (
                                                                                    <span>{value}</span>
                                                                                )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TableContainer className="d-none d-md-block">
                                    <Table>
                                        <TableHead/>
                                        <TableBody>
                                            <TableRow>
                                                <TablePagination
                                                    id={'memberPagination'}
                                                    rowsPerPageOptions={[
                                                        5,
                                                        10,
                                                        25,
                                                        {
                                                            label: 'All',
                                                            value: 1000
                                                        }
                                                    ]}
                                                    colSpan={4}
                                                    count={len}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page'
                                                        },
                                                        native: true
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                    style={{display: 'flex'}}
                                                />
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </> : <div className={'alert alert-warning text-center'}>اعضایی ثبت نشده است</div>}
                        </>}
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" onClick={closeModal}></div>
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    )
}

export default AccessGroupMember;
